import { render, staticRenderFns } from "./product-main-update-dialog.vue?vue&type=template&id=222f055d&"
import script from "./product-main-update-dialog.vue?vue&type=script&lang=js&"
export * from "./product-main-update-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports